module.exports = __webpack_public_path__ + "static/media/felicity-jones-icon.b1b4267b.jpg";